module.exports = __webpack_public_path__ + "assets/plugup.a6df73d5.svg";